<template>
  <div class="">

  </div>
</template>

<script>
export default {
  name: 'ConfiguratorInfo',
  data(){
    return {

    }
  },
  props: ['bus'],
  mounted(){

  },
  methods:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>
